import React, { useId, InputHTMLAttributes, forwardRef } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: string;
  required?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, required, className = '', ...props }, ref) => {
    const autoId = useId();
    const id = props.id ?? autoId;
    return (
      <div className={`fc ${error ? 'err' : ''} ${className}`.trim()}>
        {label && (
          <label htmlFor={id}>
            {label}
            {required && <span className="req">*</span>}
          </label>
        )}
        <input ref={ref} {...props} id={id} />
        {error && <div className="msg">{error}</div>}
        {hint && !error && <div className="cap">{hint}</div>}
      </div>
    );
  }
);

Input.displayName = 'Input';
